import React, { useEffect, useState, useRef } from 'react';
export function CustomCursor() {
  const [dotPos, setDotPos] = useState({
    x: 0,
    y: 0
  });
  const mousePos = useRef({
    x: 0,
    y: 0
  });
  const ringPos = useRef({
    x: 0,
    y: 0
  });
  const [ringState, setRingState] = useState({
    x: 0,
    y: 0
  });
  const isTouchDevice = typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches;
  useEffect(() => {
    if (isTouchDevice) return;
    const handleMouseMove = (e: MouseEvent) => {
      mousePos.current = {
        x: e.clientX,
        y: e.clientY
      };
      setDotPos({
        x: e.clientX,
        y: e.clientY
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [isTouchDevice]);
  useEffect(() => {
    if (isTouchDevice) return;
    let animationFrameId: number;
    const animate = () => {
      ringPos.current = {
        x: ringPos.current.x + (mousePos.current.x - ringPos.current.x) * 0.12,
        y: ringPos.current.y + (mousePos.current.y - ringPos.current.y) * 0.12
      };
      setRingState({
        x: ringPos.current.x,
        y: ringPos.current.y
      });
      animationFrameId = requestAnimationFrame(animate);
    };
    animationFrameId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrameId);
  }, [isTouchDevice]);
  if (isTouchDevice) return null;
  return <>
      <div className="custom-cursor-dot hidden md:block" style={{
      left: `${dotPos.x}px`,
      top: `${dotPos.y}px`
    }} data-id="element-114" />
      <div className="custom-cursor-ring hidden md:block" style={{
      left: `${ringState.x}px`,
      top: `${ringState.y}px`
    }} data-id="element-115" />
    </>;
}